/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Reinvite_ErrorInputs */



/**
* | output |
* | --- |
* | "Could not resend the invite." |
*
* @param {Partner_Admin_Reinvite_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_reinvite_error = /** @type {((inputs?: Partner_Admin_Reinvite_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Reinvite_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Einladung konnte nicht erneut gesendet werden.")
	return /** @type {LocalizedString} */ ("Could not resend the invite.")
});